import type { CSSProperties } from 'react';

import type { TypographyVariant } from './components/Typography/types';
import { fontFamily } from './typography';

export type { TypographyVariant };

export const typographyVariantStyles: Record<TypographyVariant, CSSProperties> = {
  h1: {
    fontFamily: fontFamily.sans,
    fontSize: 60,
    fontWeight: 600,
    lineHeight: '60px',
  },
  h2: {
    fontFamily: fontFamily.sans,
    fontSize: 48,
    fontWeight: 600,
    lineHeight: '48px',
  },
  h3: {
    fontFamily: fontFamily.sans,
    fontSize: 36,
    fontWeight: 600,
    lineHeight: '40px',
  },
  h4: {
    fontFamily: fontFamily.sans,
    fontSize: 30,
    fontWeight: 600,
    lineHeight: '36px',
  },
  h5: {
    fontFamily: fontFamily.sans,
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '32px',
  },
  h6: {
    fontFamily: fontFamily.sans,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
  },
  body1: {
    fontFamily: fontFamily.sans,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '26px',
  },
  body2: {
    fontFamily: fontFamily.sans,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
  },
  body3: {
    fontFamily: fontFamily.sans,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
  },
  body4: {
    fontFamily: fontFamily.sans,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
  },
  body5: {
    fontFamily: fontFamily.sans,
    fontSize: 10,
    fontWeight: 400,
    lineHeight: '14px',
  },
};
